<template>
  <div class="container-fluid">
    <Card back>
      <template slot="header">
        <h3>گزاش تیکت هـــا</h3>
        <hr />
      </template>
      <template slot="content">
        <!-- فیلترهای گزارش -->
        <div class="row" id="filters">
          <div class="col-md-2 col-12">
            <small id="LbltarixAz"> از تاریخ </small>
            <date-picker color="dimgray" v-model="$store.state.TicketReportFilter.TarixAz" clearable :editable="true" placeholder="  از تاریخ "></date-picker>
          </div>
          <div class="col-md-2 col-12">
            <small id="LbltarixAz"> تا تاریخ</small>
            <date-picker color="dimgray" v-model="$store.state.TicketReportFilter.TarixTa" clearable :editable="true" placeholder="   تا تاریخ "></date-picker>
          </div>
          <div class="col-lg-4 col-12">
            <small id="departeman">دپارتمان</small>
            <div dir="rtl">
              <treeselect
                name="demo2"
                :multiple="true"
                :clearable="true"
                :searchable="true"
                :open-on-click="true"
                :open-on-focus="false"
                :clear-on-select="false"
                :close-on-select="false"
                :always-open="false"
                :append-to-body="false"
                :options="DepartmentsOptions"
                v-model="$store.state.TicketReportFilter.departmentList"
                :normalizer="normalizer2"
                @select="SelectDepartment"
                @deselect="DeselectDepartment"
              >
              </treeselect>
            </div>
          </div>
          <div class="col-lg-4 col-12">
            <small id="users">مسئول</small>
            <div dir="rtl">
              <treeselect
                :key="usersIndex"
                name="userstree"
                :multiple="true"
                :clearable="true"
                :searchable="true"
                :open-on-click="true"
                :open-on-focus="false"
                :clear-on-select="false"
                :close-on-select="false"
                :always-open="false"
                :append-to-body="false"
                :options="Useroptions"
                v-model="$store.state.TicketReportFilter.tblUserList"
                :normalizer="normalizer3"
                @select="Selectusers"
                @deselect="DeselctUsers"
              >
              </treeselect>
            </div>
          </div>
          <div class="col-lg-4 col-12">
            <small id="LblTblCostomer">نوع تیکت</small>
            <div dir="rtl">
              <treeselect
                name="TicketType"
                :multiple="true"
                :clearable="true"
                :searchable="true"
                :open-on-click="true"
                :open-on-focus="false"
                :clear-on-select="false"
                :close-on-select="false"
                :always-open="false"
                :append-to-body="false"
                :options="TicketTypeOprtions"
                v-model="$store.state.TicketReportFilter.ticketTypeList45"
                :normalizer="normalizer3"
                @select="SelectTicketType"
                @deselect="DeselectTicketType"
              >
              </treeselect>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <small id="grp42">وضعیت</small>
            <div dir="rtl">
              <treeselect
                name="TicketStatus41"
                :multiple="true"
                :clearable="true"
                :searchable="true"
                :open-on-click="true"
                :open-on-focus="false"
                :clear-on-select="false"
                :close-on-select="false"
                :always-open="false"
                :append-to-body="false"
                :options="TicketStatus41Options"
                v-model="$store.state.TicketReportFilter.TicketStatus41"
                :normalizer="normalizer3"
                @select="SelectTicketStatus41"
                @deselect="DeselectTicketStatus41"
              >
                <label slot="option-label" slot-scope="{ labelClassName, node }" :class="labelClassName">{{ node.label }}</label>
              </treeselect>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <button class="btn btn-success w-100 mt-4" @click="BuildReport">ساخت گزارش</button>
          </div>
        </div>
      </template>
    </Card>
    <TicketReportCard v-for="(report, index) in Result" :dates="[filters.TarixAz, filters.TarixTa]" :key="index" :ReportDetail="report"> </TicketReportCard>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Treeselect from '@riophae/vue-treeselect'
import TicketReportCard from './Components/TicketReportCard.vue'

export default {
  data() {
    return {
      filters: { TarixAz: null, TarixTa: null, departmentList: [], tblUserList: [], ticketTypeList45: [], TicketStatus41: [] },
      usersIndex: 0,
      DepartmentsOptions: [],
      Useroptions: [],
      TicketTypeOprtions: [],
      TicketStatus41Options: [],
      normalizer2(node) {
        return {
          id: node.id,
          label: node.departmentName,
        }
      },
      normalizer3(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      Result: [],
    }
  },
  components: { Card, BnpGrid, datePicker: VuePersianDatetimePicker, Treeselect, TicketReportCard },
  methods: {
    SelectDepartment(node) {
      this.$store.state.TicketReportFilter.departmentList.push(node.id)
      this.GetDepartmentUsers(false)
    },
    DeselectDepartment(node) {
      var index = this.$store.state.TicketReportFilter.departmentList.indexOf(node.id)
      if (index >= 0) {
        this.$store.state.TicketReportFilter.departmentList.splice(index, 1)
      }
      this.GetDepartmentUsers(false)
    },
    GetAllDepartmentsOptions() {
      var DataAxios = { Method: 'GET', Action: 'Ticket/GetDepartmentForCombo', ArryfildValue: null }

      this.$PostData(DataAxios).then((data) => {
        if (data.status != 'Not Ok') {
          this.DepartmentsOptions = data
        }
      })
    },
    Selectusers(node) {
      this.$store.state.TicketReportFilter.tblUserList.push(node.id)
    },
    DeselctUsers(node) {
      var index = this.$store.state.TicketReportFilter.tblUserList.indexOf(node.id)
      if (index >= 0) {
        this.$store.state.TicketReportFilter.tblUserList.splice(index, 1)
      }
    },
    GetDepartmentUsers(fromCreated) {
      if (this.$store.state.TicketReportFilter.departmentList.length == 0) {
        this.Useroptions = []
        this.$store.state.TicketReportFilter.tblUserList = []
      } else {
        var DataAxios = { Method: 'POST', Action: 'TblCrmCombo/GetUserDatailsByDepartment', ArryfildValue: { DepartmentIds: this.$store.state.TicketReportFilter.departmentList.toString() } }
        this.$PostData(DataAxios).then((result) => {
          this.Useroptions = result
          if (!fromCreated) {
            //#region  اپدیت مسئول تیکت بعد از تغییر دپارتمان
            let indexsSpliceUsers = []
            this.$store.state.TicketReportFilter.departmentList.forEach((el) => {
              let find = this.Useroptions.find((x) => x.id == el)
              if (find == undefined) {
                indexsSpliceUsers.push(el)
              }
            })

            indexsSpliceUsers.forEach((el) => {
              let vla3Find = this.$store.state.TicketReportFilter.tblUserList.find((x) => x == el)
              let index = this.$store.state.TicketReportFilter.tblUserList.indexOf(vla3Find)
              this.$store.state.TicketReportFilter.tblUserList.splice(index, 1)
            })
          } //#endregion
          this.usersIndex++
        })
      }
    },
    SelectTicketType(node) {
      this.$store.state.TicketReportFilter.ticketTypeList45.push(node.id)
    },
    DeselectTicketType(node) {
      var index = this.$store.state.TicketReportFilter.ticketTypeList45.indexOf(node.id)
      if (index >= 0) {
        this.$store.state.TicketReportFilter.ticketTypeList45.splice(index, 1)
      }
    },
    GetTicketTypeOptions() {
      let Dataaxios = {
        Action: 'TblCrmCombo/GetComboById',
        Method: 'Post',
        ArryfildValue: {
          Id: 45,
        },
      }
      this.$PostData(Dataaxios).then((res) => {
        this.TicketTypeOprtions = res
      })
    },
    SelectTicketStatus41(node) {
      this.$store.state.TicketReportFilter.TicketStatus41.push(node.id)
    },
    DeselectTicketStatus41(node) {
      var index = this.$store.state.TicketReportFilter.TicketStatus41.indexOf(node.id)
      if (index >= 0) {
        this.$store.state.TicketReportFilter.TicketStatus41.splice(index, 1)
      }
    },
    GetTicketStatus41Options() {
      var DataAxios = { Method: 'Post', Action: 'TblCrmCombo/GetComboById', ArryfildValue: { Id: 41 } }
      this.$PostData(DataAxios).then((data) => {
        if (data.status != 'Not Ok') {
          this.TicketStatus41Options = data
        }
      })
    },
    BuildReport() {
      this.$store.state.loading = true
      var DataAxios = { Method: 'POST', Action: 'Ticket/TicketReport', ArryfildValue: this.$store.state.TicketReportFilter }
      this.$PostData(DataAxios).then((result) => {
        this.Result = result
        this.$store.state.loading = false
      })
    },
  },
  created() {
    this.GetAllDepartmentsOptions()
    this.GetTicketTypeOptions()
    this.GetTicketStatus41Options()
    if (this.$store.state.TicketReportFilter.departmentList.length > 0) {
      this.GetDepartmentUsers(true)
    }
  },
}
</script>
